import { EXCHANGE_RATE_DECIMAL_VIEW_NUMBER, taytanFormatNumberToString } from '../../utils/mathUtils';

import { RATE_TABLE_FROM_WIDTH, RATE_TABLE_RATE_WIDTH, RATE_TABLE_TO_WIDTH } from './pdfStyles';

export const rateTableColumns = [
    { title: 'From', fieldName: 'from', style: { minWidth: `${RATE_TABLE_FROM_WIDTH}px` } },
    { title: 'To', fieldName: 'to', style: { minWidth: `${RATE_TABLE_TO_WIDTH}px` } },
    { title: 'Rate', fieldName: 'rate', style: { minWidth: `${RATE_TABLE_RATE_WIDTH}px` } }
];

export const getPdfRateTableRow = (from?: string, to?: string, rate?: number | null) => {
    return {
        from: from || '',
        to: to || '',
        rate:
            `${
                rate || rate === 0
                    ? taytanFormatNumberToString(rate, EXCHANGE_RATE_DECIMAL_VIEW_NUMBER)
                    : 'No Rate'
            }` || ''
    };
};
